import { StyleSheet, css } from 'aphrodite';
import React from 'react';

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var lib = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, '__esModule', { value: true });

var capitalize = function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

var fromCamelToSentence = function fromCamelToSentence(camelCaseString) {
    return capitalize(camelCaseString.split(/(?=[A-Z])/).join(' '));
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/* eslint-disable security/detect-object-injection */

var extractMetadata = function extractMetadata() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var extraction = {};
    Object.keys(props).forEach(function (key) {
        if (!props[key]) {
            return;
        }
        var propType = props[key].type ? props[key].type : props[key];
        var label = props[key].label === undefined ? fromCamelToSentence(key) : props[key].label;
        extraction[key] = _extends({}, propType._meta, {
            label: label,
            propName: key,
            isPrivate: props[key].isPrivate,
            tooltip: props[key].tooltip
        });
    });
    return extraction;
};

/* eslint-disable security/detect-object-injection */

var PropTypes = {};

function getShim() {
    function shim() {}
    function requiredShim() {}
    shim.isRequired = requiredShim;
    return shim;
}

['array', 'bool', 'string', 'color', 'number', 'image', 'slider', 'media', 'product', 'category', 'sectionHeader', 'editorFull', 'editorMinimal', 'readOnly', 'date', 'dateRange'].forEach(function (type) {
    PropTypes[type] = getShim();
});

['component', 'objectOf', 'arrayOf', 'oneOf', 'shape', 'embeddable'].forEach(function (type) {
    PropTypes[type] = getShim;
});

var defaults$1 = {
    image: {
        uriBase: '',
        imagePath: '',
        altText: '',
        width: 0,
        height: 0
    },
    slider: {
        min: 0,
        max: 10,
        stepSize: 1,
        selectedValue: 0
    }
};

var primitiveProp = function primitiveProp(type) {
    var checker = PropTypes[type];
    checker._meta = { type: type };
    checker.isRequired._meta = { type: type, isRequired: true };
    if (defaults$1[type]) {
        checker.default = defaults$1[type];
    }

    return checker;
};

var createTypeOfTypeChecker = function createTypeOfTypeChecker(type) {
    return function (arrType) {
        var appliedChecker = PropTypes[type](arrType);
        appliedChecker._meta = {
            type: type,
            argType: arrType._meta
        };
        appliedChecker.isRequired._meta = _extends({}, appliedChecker._meta, {
            isRequired: true
        });
        return appliedChecker;
    };
};

var createEnumTypeChecker = function createEnumTypeChecker(expectedValues) {
    var appliedChecker = PropTypes.oneOf(expectedValues);
    appliedChecker._meta = {
        type: 'oneOf',
        values: expectedValues
    };
    appliedChecker.isRequired._meta = _extends({}, appliedChecker._meta, {
        isRequired: true
    });
    return appliedChecker;
};

var createShapeTypeChecker = function createShapeTypeChecker(type) {
    return function (shapeObj) {
        var appliedChecker = PropTypes.shape(shapeObj);
        var objMeta = extractMetadata(shapeObj);

        appliedChecker._meta = {
            type: type,
            objMeta: objMeta
        };
        appliedChecker.isRequired._meta = _extends({}, appliedChecker._meta, {
            isRequired: true
        });
        return appliedChecker;
    };
};

var componentTypeChecker = function componentTypeChecker(name) {
    var appliedChecker = PropTypes.shape({ name: name });

    appliedChecker._meta = {
        type: 'component',
        allowedComponents: [name]
    };
    appliedChecker.isRequired._meta = _extends({}, appliedChecker._meta, {
        isRequired: true
    });
    return appliedChecker;
};

var createComponentTypeChecker = function createComponentTypeChecker() {
    return componentTypeChecker;
};

var ElementPropTypes = {
    _version: '1.0.17-0',
    array: primitiveProp('array'),
    bool: primitiveProp('bool'),
    color: primitiveProp('color'),
    media: primitiveProp('media'),
    editorFull: primitiveProp('editorFull'),
    editorMinimal: primitiveProp('editorMinimal'),
    number: primitiveProp('number'),
    string: primitiveProp('string'),
    product: primitiveProp('product'),
    category: primitiveProp('category'),
    sectionHeader: primitiveProp('sectionHeader'),
    image: primitiveProp('image'),
    slider: primitiveProp('slider'),
    date: primitiveProp('date'),
    dateRange: primitiveProp('dateRange'),
    arrayOf: createTypeOfTypeChecker('arrayOf'),
    objectOf: createTypeOfTypeChecker('objectOf'),
    embeddable: createShapeTypeChecker('embeddable'),
    oneOf: createEnumTypeChecker,
    shape: createShapeTypeChecker('shape'),
    readOnly: primitiveProp('readOnly'),
    component: createComponentTypeChecker()
};

exports.ElementPropTypes = ElementPropTypes;
exports.extractMetadata = extractMetadata;
});

unwrapExports(lib);
var lib_1 = lib.ElementPropTypes;
var lib_2 = lib.extractMetadata;

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var getBorderRadius = function getBorderRadius(cornerStyle) {
    if (cornerStyle === 'small') return '.125rem';
    if (cornerStyle === 'medium') return '.25rem';
    if (cornerStyle === 'large') return '.5rem';
    if (cornerStyle === 'pill') return '9999px';
    return '0';
};

var getBorders = function getBorders(borderThickness) {
    if (borderThickness === 'basic') {
        return {
            borderStyle: 'solid',
            borderWidth: '.125rem'
        };
    }
    if (borderThickness === 'thin') {
        return {
            borderStyle: 'solid',
            borderWidth: '1px'
        };
    }
    if (borderThickness === 'thick') {
        return {
            borderStyle: 'solid',
            borderWidth: '.25rem'
        };
    }
    return {
        borderStyle: 'none',
        borderWidth: 0
    };
};

var getSizes = function getSizes(size) {
    if (size === 'small') {
        return {
            fontSize: '.75rem',
            padding: '.25rem .5rem'
        };
    }
    if (size === 'medium') {
        return {
            fontSize: '.875rem',
            padding: '.5rem 1rem'
        };
    }
    if (size === 'large') {
        return {
            fontSize: '1rem',
            padding: '1rem 2rem'
        };
    }
    if (size === 'xlarge') {
        return {
            fontSize: '1.25rem',
            padding: '1.25rem 2.5rem',
            width: '100%',
            maxWidth: '30em'
        };
    }
    return {
        fontSize: '1rem',
        padding: '1rem 2rem',
        width: '100%'
    };
};

var getLetterSpacing = function getLetterSpacing(spacing) {
    if (spacing === 'tracked') return '.1em';
    if (spacing === 'tight') return '-.05em';
    if (spacing === 'mega') return '.25em';
    return '';
};

var getGrowOnHover = function getGrowOnHover(grow) {
    return grow && {
        '-moz-osx-font-smoothing': 'grayscale',
        '-webkit-backface-visibility': 'hidden',
        backfaceVisibility: 'hidden',
        transform: 'translateZ(0)',
        transition: 'transform .25s ease-out',
        ':hover': {
            transform: 'scale(1.05)'
        },
        ':focus': {
            transform: 'scale(1.05)'
        },
        ':active': {
            transform: 'scale(.90)'
        }
    };
};

var getClasses = function getClasses(buttonSettings) {
    var styles = {
        button: _extends({
            backgroundColor: buttonSettings.backgroundColor,
            borderColor: buttonSettings.borderColor,
            borderRadius: getBorderRadius(buttonSettings.rounded),
            color: buttonSettings.textColor || 'white',
            cursor: 'pointer',
            display: 'inline-block',
            fontWeight: buttonSettings.fontWeight,
            letterSpacing: getLetterSpacing(buttonSettings.letterSpacing),
            textAlign: 'center',
            textDecoration: 'none',
            textTransform: buttonSettings.textTransform,
            transition: 'color .15s ease-in',
            ':hover': {
                backgroundColor: buttonSettings.hoverBackgroundColor,
                borderColor: buttonSettings.hoverBorderColor,
                color: buttonSettings.hoverTextColor || 'white',
                textDecoration: 'none',
                transition: 'all .2s ease-in-out'
            },
            ':active': { transition: 'color .15s ease-in' },
            ':visited': { transition: 'color .15s ease-in' },
            ':link': { transition: 'color .15s ease-in' },
            ':focus': {
                transition: 'color .15s ease-in',
                outline: '1px dotted currentColor'
            }
        }, getBorders(buttonSettings.borderThickness), getSizes(buttonSettings.size), getGrowOnHover(buttonSettings.growOnHover))
    };

    return StyleSheet.create(styles);
};

var LinkButton = function LinkButton(_ref) {
    var text = _ref.text,
        href = _ref.href,
        newWindow = _ref.newWindow,
        className = _ref.className;
    return React.createElement(
        'a',
        { href: href, target: newWindow ? '_blank' : '_self' },
        React.createElement(
            'button',
            { className: className },
            text
        )
    );
};

var StandardButton = function StandardButton(_ref) {
    var text = _ref.text,
        className = _ref.className;
    return React.createElement(
        'button',
        { className: className },
        text
    );
};

var Button = function Button(props) {
    var volComponentButton = props.globalSettings.globalComponents.volComponentButton;
    var primaryButtonStyles = volComponentButton.primaryButtonStyles,
        secondaryButtonStyles = volComponentButton.secondaryButtonStyles;


    var BaseButton = function BaseButton(props) {
        var classes = getClasses(props.globalButtonSettings);
        return props.href ? React.createElement(LinkButton, _extends({}, props, { className: css(classes.button) })) : React.createElement(StandardButton, _extends({}, props, { className: css(classes.button) }));
    };

    return React.createElement(BaseButton, _extends({}, props, {
        globalButtonSettings: props.buttonStyle === 'Primary' ? primaryButtonStyles : secondaryButtonStyles
    }));
};

var block = Button;

var defaultConfig = {
    buttonStyle: 'Primary',
    href: '',
    text: 'My Button',
    newWindow: false
};

var configSchema = {
    buttonStyle: {
        label: 'Button Style',
        type: lib_1.oneOf(['Primary', 'Secondary'])
    },
    href: {
        label: 'Button Link',
        type: lib_1.string
    },
    text: {
        label: 'Button Text',
        type: lib_1.string
    },
    newWindow: {
        label: 'Open link in a new window',
        type: lib_1.bool
    }
};

var Button$1 = /*#__PURE__*/Object.freeze({
	block: block,
	defaultConfig: defaultConfig,
	configSchema: configSchema
});

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

{
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var styles = (function (_ref) {
    var primary = _ref.primary,
        secondary = _ref.secondary;

    return {
        baseStyles: {
            textAlign: 'center',
            textDecoration: 'none',
            transition: 'color .15s ease-in',
            display: 'inline-block',
            cursor: 'pointer',
            ':hover': { transition: 'color .15s ease-in' },
            ':active': { transition: 'color .15s ease-in' },
            ':visited': { transition: 'color .15s ease-in' },
            ':link': { transition: 'color .15s ease-in' },
            ':focus': {
                transition: 'color .15s ease-in',
                outline: '1px dotted currentColor'
            }
        },
        borderBasic: {
            borderStyle: 'solid',
            borderWidth: '.125rem'
        },
        borderThin: {
            borderStyle: 'solid',
            borderWidth: '1px'
        },
        borderThick: {
            borderStyle: 'solid',
            borderWidth: '.25rem'
        },
        borderNone: {
            borderStyle: 'none',
            borderWidth: 0
        },
        sizeSmall: {
            fontSize: '.75rem',
            paddingTop: '.25rem',
            paddingBottom: '.25rem',
            paddingLeft: '.5rem',
            paddingRight: '.5rem'
        },
        sizeMedium: {
            fontSize: '.875rem',
            paddingTop: '.5rem',
            paddingBottom: '.5rem',
            paddingLeft: '1rem',
            paddingRight: '1rem'
        },
        sizeLarge: {
            fontSize: '1rem',
            paddingTop: '1rem',
            paddingBottom: '1rem',
            paddingLeft: '2rem',
            paddingRight: '2rem'
        },
        sizeXLarge: {
            fontSize: '1.25rem',
            paddingTop: '1.25rem',
            paddingBottom: '1.25rem',
            paddingLeft: '2.5rem',
            paddingRight: '2.5rem',
            width: '100%',
            maxWidth: '30em'
        },
        sizeBlock: {
            fontSize: '1rem',
            paddingTop: '1rem',
            paddingBottom: '1rem',
            paddingLeft: '2rem',
            paddingRight: '2rem',
            width: '100%'
        },
        cornerNone: {
            borderRadius: 0
        },
        cornerSmall: {
            borderRadius: '.125rem'
        },
        cornerMedium: {
            borderRadius: '.25rem'
        },
        cornerLarge: {
            borderRadius: '.5rem'
        },
        cornerPill: {
            borderRadius: '9999px'
        },
        weight300: {
            fontWeight: 300
        },
        weight400: {
            fontWeight: 400
        },
        weight500: {
            fontWeight: 500
        },
        weight600: {
            fontWeight: 600
        },
        weight700: {
            fontWeight: 700
        },
        weight800: {
            fontWeight: 800
        },
        weight900: {
            fontWeight: 900
        },
        textTransformNone: {
            textTransform: 'none'
        },
        textTransformCapitalize: {
            textTransform: 'capitalize'
        },
        textTransformLowercase: {
            textTransform: 'lowercase'
        },
        textTransformUppercase: {
            textTransform: 'uppercase'
        },
        spacingNone: {},
        spacingTracked: {
            letterSpacing: '.1em'
        },
        spacingTight: {
            letterSpacing: '-.05em'
        },
        spacingMega: {
            letterSpacing: '.25em'
        },
        grow: {
            '-moz-osx-font-smoothing': 'grayscale',
            '-webkit-backface-visibility': 'hidden',
            backfaceVisibility: 'hidden',
            transform: 'translateZ(0)',
            transition: 'transform .25s ease-out',
            ':hover': {
                transform: 'scale(1.05)'
            },
            ':focus': {
                transform: 'scale(1.05)'
            },
            ':active': {
                transform: 'scale(.90)'
            }
        },
        primaryButton: {
            backgroundColor: primary.backgroundColor,
            borderColor: primary.borderColor,
            color: primary.textColor || 'white'
        },
        primaryButtonHover: {
            ':hover': {
                backgroundColor: primary.hoverBackgroundColor,
                borderColor: primary.hoverBorderColor,
                color: primary.hoverTextColor || 'white',
                textDecoration: 'none',
                transition: 'all 0.2s ease-in-out'
            }
        },
        secondaryButton: {
            backgroundColor: secondary.backgroundColor,
            borderColor: secondary.borderColor,
            color: secondary.textColor || 'white'
        },
        secondaryButtonHover: {
            ':hover': {
                backgroundColor: secondary.hoverBackgroundColor,
                borderColor: secondary.hoverBorderColor,
                color: secondary.hoverTextColor || 'white',
                textDecoration: 'none',
                transition: 'all 0.2s ease-in-out'
            }
        }
    };
});

var name = 'volComponentButton';

var baseButtonStylesConfig = {
    textColor: '#fff',
    hoverTextColor: '#fff',
    backgroundColor: '#333',
    hoverBackgroundColor: '#555',
    borderColor: '#333333',
    hoverBorderColor: '#555',
    fontWeight: '700', // 300, 400, 500, 600, 700, 800, 900
    textTransform: 'none', // none, capitalize, lowercase, uppercase
    letterSpacing: 'none', // none, tracked, tight, mega
    borderThickness: 'basic', // basic, thin, thick, none
    size: 'medium', // small, medium, large, block
    rounded: 'medium', // none, small, medium, large, pill
    growOnHover: false
};

var defaultConfig$1 = {
    buttonStyle: 'primary',
    className: '',
    href: '',
    primaryButtonStyles: _extends({}, baseButtonStylesConfig),
    secondaryButtonStyles: _extends({}, baseButtonStylesConfig, {
        textColor: '#666',
        hoverTextColor: '#333',
        backgroundColor: '#fff',
        hoverBackgroundColor: '#f2f2f2',
        borderColor: '#666',
        hoverBorderColor: '#333'
    })
};

var factory = function factory(_ref, _ref2, _ref3) {
    var React$$1 = _ref.React,
        ElementPropTypes = _ref.ElementPropTypes;
    var StyleSheet$$1 = _ref2.StyleSheet,
        css$$1 = _ref2.css;
    var globalComponents = _ref3.globalComponents;

    var buttonGlobalStyles = globalComponents.volComponentButton;
    var mergedComponentStyles = {
        primary: _extends({}, defaultConfig$1.primaryButtonStyles, (buttonGlobalStyles || {}).primaryButtonStyles),
        secondary: _extends({}, defaultConfig$1.secondaryButtonStyles, (buttonGlobalStyles || {}).secondaryButtonStyles)
    };
    var classes = StyleSheet$$1.create(styles(mergedComponentStyles));
    var buttonStylesConfigSpec = {
        textColor: ElementPropTypes.color.isRequired,
        hoverTextColor: ElementPropTypes.color.isRequired,
        backgroundColor: ElementPropTypes.color.isRequired,
        hoverBackgroundColor: ElementPropTypes.color.isRequired,
        borderColor: ElementPropTypes.color.isRequired,
        hoverBorderColor: ElementPropTypes.color.isRequired,
        fontWeight: ElementPropTypes.oneOf(['300', '400', '500', '600', '700', '800', '900']).isRequired,
        textTransform: ElementPropTypes.oneOf(['none', 'capitalize', 'lowercase', 'uppercase']).isRequired,
        borderThickness: ElementPropTypes.oneOf(['basic', 'thin', 'thick', 'none']).isRequired,
        size: ElementPropTypes.oneOf(['small', 'medium', 'large', 'xlarge', 'block']).isRequired,
        rounded: ElementPropTypes.oneOf(['none', 'small', 'medium', 'large', 'pill']).isRequired,
        growOnHover: ElementPropTypes.bool.isRequired
    };
    var configSpec = {
        children: ElementPropTypes.array,
        primaryButtonStyles: ElementPropTypes.shape(buttonStylesConfigSpec),
        secondaryButtonStyles: ElementPropTypes.shape(buttonStylesConfigSpec)
    };

    var component = function (_React$Component) {
        inherits(component, _React$Component);

        function component() {
            var _ref4;

            var _temp, _this, _ret;

            classCallCheck(this, component);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref4 = component.__proto__ || Object.getPrototypeOf(component)).call.apply(_ref4, [this].concat(args))), _this), _this.configClasses = function (_ref5) {
                var fontWeight = _ref5.fontWeight,
                    letterSpacing = _ref5.letterSpacing,
                    textTransform = _ref5.textTransform,
                    borderThickness = _ref5.borderThickness,
                    size = _ref5.size,
                    rounded = _ref5.rounded,
                    growOnHover = _ref5.growOnHover;

                var base = classes.baseStyles;
                var borders = {
                    basic: classes.borderBasic,
                    thin: classes.borderThin,
                    thick: classes.borderThick,
                    none: classes.borderNone
                };
                var sizes = {
                    small: classes.sizeSmall,
                    medium: classes.sizeMedium,
                    large: classes.sizeLarge,
                    xlarge: classes.sizeXLarge,
                    block: classes.sizeBlock
                };
                var corners = {
                    none: classes.cornerNone,
                    small: classes.cornerSmall,
                    medium: classes.cornerMedium,
                    large: classes.cornerLarge,
                    pill: classes.cornerPill
                };
                var weight = {
                    300: classes.weight300,
                    400: classes.weight400,
                    500: classes.weight500,
                    600: classes.weight600,
                    700: classes.weight700,
                    800: classes.weight800,
                    900: classes.weight900
                };
                var text = {
                    none: classes.textTransformNone,
                    capitalize: classes.textTransformCapitalize,
                    lowercase: classes.textTransformLowercase,
                    uppercase: classes.textTransformUppercase
                };

                var spacing = {
                    none: null,
                    tracked: classes.spacingTracked,
                    tight: classes.spacingTight,
                    mega: classes.spacingMega
                };

                var grow = growOnHover ? classes.grow : null;

                /* eslint-disable security/detect-object-injection */
                return css$$1(base, text[textTransform], weight[fontWeight], borders[borderThickness], sizes[size], corners[rounded], spacing[letterSpacing], grow);
                /* eslint-enable security/detect-object-injection */
            }, _this.getButtonClasses = function (role, styles$$1) {
                var baseStyles = _this.configClasses(styles$$1);
                if (role === 'secondary') {
                    return baseStyles + ' ' + css$$1(classes.secondaryButton, classes.secondaryButtonHover);
                } else {
                    return baseStyles + ' ' + css$$1(classes.primaryButton, classes.primaryButtonHover);
                }
            }, _temp), possibleConstructorReturn(_this, _ret);
        }

        createClass(component, [{
            key: 'render',
            value: function render() {
                var _props = this.props,
                    children = _props.children,
                    buttonStyle = _props.buttonStyle,
                    className = _props.className,
                    rest = objectWithoutProperties(_props, ['children', 'buttonStyle', 'className']);

                var classExtensions = className ? className : '';
                var styles$$1 = buttonStyle === 'secondary' ? mergedComponentStyles.secondary : mergedComponentStyles.primary;
                return React$$1.createElement(
                    React$$1.Fragment,
                    null,
                    this.props.href ? React$$1.createElement(
                        'a',
                        _extends({
                            className: this.getButtonClasses(buttonStyle, styles$$1) + ' ' + classExtensions
                        }, rest),
                        children
                    ) : React$$1.createElement(
                        'button',
                        _extends({
                            className: this.getButtonClasses(buttonStyle, styles$$1) + ' ' + classExtensions
                        }, rest),
                        children
                    )
                );
            }
        }]);
        return component;
    }(React$$1.Component);

    component.propTypes = _extends({
        className: propTypes.string,
        buttonStyle: propTypes.string,
        extendClasses: propTypes.string,
        href: propTypes.string
    }, configSpec);

    return {
        component: component,
        config: configSpec
    };
};

var LegacyButton = /*#__PURE__*/Object.freeze({
	factory: factory,
	defaultConfig: defaultConfig$1,
	name: name
});

var Logo = function Logo(_ref) {
    var style = _ref.style,
        Image = _ref.Image,
        StoreName = _ref.StoreName;

    if (style === 'Image') {
        return React.createElement(Image, null);
    }

    return React.createElement(StoreName, null);
};

var block$1 = Logo;

var Logo$1 = /*#__PURE__*/Object.freeze({
	block: block$1
});

var defaultConfig$2 = {
    alt: '',
    height: 270,
    src: 'https://res.cloudinary.com/dyx4yhvoq/image/upload/v1545428185/images/tcp-no-image.jpg',
    title: '',
    width: 360
};

var configSchema$1 = {
    src: {
        label: 'Image',
        type: lib_1.string
    },
    title: {
        label: 'Title',
        type: lib_1.string
    },
    altText: {
        label: 'Alt Text',
        type: lib_1.string
    },
    width: {
        label: 'Width',
        type: lib_1.number
    },
    height: {
        label: 'Height',
        type: lib_1.number
    }
};

var responsiveImgStyles = {
    maxWidth: '100%'
};

var AmpImg = function AmpImg(props) {
    return React.createElement('amp-img', props);
};
var Img = function Img(props) {
    return React.createElement(
        'picture',
        null,
        React.createElement('img', _extends({}, props, { style: responsiveImgStyles }))
    );
};

var Image = function Image(_ref) {
    var alt = _ref.alt,
        height = _ref.height,
        src = _ref.src,
        title = _ref.title,
        utils = _ref.utils,
        width = _ref.width;

    var imgProps = { alt: alt, height: height, src: src, title: title, width: width };

    return utils.isAmpRequest ? React.createElement(AmpImg, _extends({ layout: 'responsive' }, imgProps)) : React.createElement(Img, imgProps);
};

var block$2 = Image;

var Image$1 = /*#__PURE__*/Object.freeze({
	block: block$2,
	configSchema: configSchema$1,
	defaultConfig: defaultConfig$2
});

var Text = function Text(_ref) {
    var htmlString = _ref.htmlString,
        props = objectWithoutProperties(_ref, ['htmlString']);

    if (!htmlString) return null;
    // We delete the unused globalSettings prop so that React won't complain about it not being a valid DOM attribute.
    delete props.globalSettings;
    return React.createElement('div', _extends({}, props, { dangerouslySetInnerHTML: { __html: htmlString } }));
};

var block$3 = Text;

var defaultConfig$3 = {
    htmlString: 'Lorem Ipsum'
};

var configSchema$2 = {
    htmlString: {
        label: 'Text Content',
        type: lib_1.editorMinimal
    }
};

var Text$1 = /*#__PURE__*/Object.freeze({
	block: block$3,
	defaultConfig: defaultConfig$3,
	configSchema: configSchema$2
});

var getStyles = function getStyles(blockConfig, globalSettings) {
    var mobileStyles = blockConfig.showOnMobile === false ? {
        '@media only screen and (max-width: 30em)': {
            display: 'none'
        }
    } : {};
    var tabletStyles = blockConfig.showOnTablet === false ? {
        '@media only screen and (min-width: 30em) and (max-width: 60em)': {
            display: 'none'
        }
    } : {};
    var desktopStyles = blockConfig.showOnDesktop === false ? {
        '@media only screen and (min-width: 60em)': {
            display: 'none'
        }
    } : {};
    return {
        wrapper: _extends({
            width: '100%',
            maxWidth: blockConfig.isFullWidth ? undefined : '96rem',
            paddingRight: blockConfig.hasHorizontalPadding ? '1rem' : undefined,
            paddingLeft: blockConfig.hasHorizontalPadding ? '1rem' : undefined,
            paddingTop: getPaddingAmount(blockConfig.topPadding, globalSettings),
            paddingBottom: getPaddingAmount(blockConfig.bottomPadding, globalSettings)
        }, mobileStyles, tabletStyles, desktopStyles)
    };
};

var getPaddingAmount = function getPaddingAmount(paddingSize, globalSettings) {
    if (/^small$/i.test(paddingSize)) return '0.5rem';
    if (/^medium$/i.test(paddingSize)) return '1rem';
    if (/^large$/i.test(paddingSize)) return '1.5rem';
};

var configSchema$3 = {
    isFullWidth: {
        label: 'Full width',
        type: lib_1.bool
    },
    hasHorizontalPadding: {
        label: 'Horizontal spacing',
        type: lib_1.bool
    },
    topPadding: {
        label: 'Top spacing',
        type: lib_1.oneOf(['None', 'Small', 'Medium', 'Large'])
    },
    bottomPadding: {
        label: 'Top spacing',
        type: lib_1.oneOf(['None', 'Small', 'Medium', 'Large'])
    },
    showOnDesktop: {
        label: 'Show on desktop',
        type: lib_1.bool
    },
    showOnTablet: {
        label: 'Show on tablet',
        type: lib_1.bool
    },
    showOnMobile: {
        label: 'Show on mobile',
        type: lib_1.bool
    },
    customAttrs: {
        label: 'Custom element attributes',
        type: lib_1.arrayOf(lib_1.shape({
            name: {
                label: 'Name',
                tooltip: 'All entered values are automatically prefixed with "data-element-". Example: "data-element-your-custom-attribute-name"',
                type: lib_1.string
            },
            value: {
                label: 'Value',
                type: lib_1.string
            }
        }))
    }
};

var defaultConfig$4 = {
    isFullWidth: true,
    hasHorizontalPadding: false,
    topPadding: 'None',
    bottomPadding: 'None',
    showOnDesktop: true,
    showOnTablet: true,
    showOnMobile: true,
    customAttrs: [{
        name: '',
        value: ''
    }]
};

var Block = function Block(props) {
    var globalSettings = props.globalSettings,
        customAttrs = props.customAttrs,
        children = props.children;

    if (!children) return null;
    var styles = StyleSheet.create(getStyles(props, globalSettings));
    var customProps = {};
    customAttrs.filter(function (attr) {
        return attr.name;
    }).forEach(function (attr) {
        var hyphenateString = function hyphenateString() {
            var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            var specialChars = /[^a-zA-Z0-9\s-_]+/g;
            var nonAlphaNumericChars = /[^a-zA-Z0-9]+/g;
            var attr = string.trim().replace(specialChars, '').replace(nonAlphaNumericChars, '-').toLowerCase();
            return attr;
        };
        var fullAttrName = 'data-element-' + hyphenateString(attr.name);
        customProps[fullAttrName] = attr.value;
    });
    return React.createElement(
        'div',
        _extends({ className: css(styles.wrapper) }, customProps),
        children
    );
};

Block.defaultProps = defaultConfig$4;



var index$1 = /*#__PURE__*/Object.freeze({
	block: Block,
	configSchema: configSchema$3,
	defaultConfig: defaultConfig$4
});

var LegacyComponents = {
    Button: LegacyButton
};

var StandardComponents = {
    Button: Button$1,
    Image: Image$1,
    Logo: Logo$1,
    Text: Text$1
};

export { index$1 as ElementBlock, LegacyComponents, StandardComponents };
